import React from 'react';
import { MFEErrorBoundary } from '@capsplus/mfe-common';

/**
 * MFEComponentWrapper
 *
 * Wraps dynamically loaded MFE components with error boundary protection.
 * Provides graceful error handling for microfrontends that fail to load or crash.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.component - The MFE component to render
 * @param {string} props.mfeName - Name of the MFE (for error reporting)
 * @param {string} props.displayName - Display name for the tab/page
 * @param {Function} props.onError - Optional callback when error occurs
 * @param {Function} props.onRetry - Optional callback when user retries
 */
const MFEComponentWrapper = ({
  component: Component,
  mfeName,
  displayName,
  onError,
  onRetry
}) => {
  // If no component provided, show fallback
  if (!Component) {
    return (
      <div style={{ padding: '20px' }}>
        <h2>{displayName}</h2>
        <p>Content for {displayName}</p>
        <p>This is where the actual component would be rendered.</p>
      </div>
    );
  }

  // Wrap component in error boundary with retry support
  return (
    <MFEErrorBoundary
      mfeName={mfeName || displayName || 'Microfrontend'}
      onError={onError}
      onRetry={onRetry}
    >
      <Component />
    </MFEErrorBoundary>
  );
};

export default MFEComponentWrapper;
